import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';

import PrivacyRequestForm from './PrivacyRequestForm';
import PrivacyNotEligible from './PrivacyNotEligible';
import PrivacyVerificationEmailSent from './PrivacyVerificationEmailSent';
import PrivacyVerificationSuccess from './PrivacyVerificationSuccess';
import PrivacyVerificationFailed from './PrivacyVerificationFailed';
import PrivacyVerificationDuplicate from './PrivacyVerificationDuplicate';

function PrivacyRequest() {
  return (
    <Router>
      <Switch>
        <Route path="/ccpa" render={withRouter(PrivacyRequestForm)} />
        <Route
          path="/privacy-form-submitted"
          render={PrivacyVerificationEmailSent}
        />
        <Route path="/privacy-not-eligible" render={PrivacyNotEligible} />
        <Route
          path="/data-privacy/confirm"
          render={PrivacyVerificationSuccess}
        />
        <Route
          path="/privacy-verification-failed"
          render={PrivacyVerificationFailed}
        />
        <Route
          path="/privacy-duplicate"
          render={PrivacyVerificationDuplicate}
        />
      </Switch>
    </Router>
  );
}

export default PrivacyRequest;
